import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Marko Tomik',
    title: "Aviation Engineer Student",
    desciption:"Located in Tartu, Estonia ",
    image: 'https://pbs.twimg.com/profile_images/1515070462199570439/srnJxngo_400x400.jpg'
    
}
